import { useRemoteComponent } from '@components/Hooks/useRemoteComponent';
import { IWidget } from '@src/interfaces';
import Classify from '@utils/Classify';
import React, { PropsWithChildren } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

interface Props extends PropsWithChildren {
  widget: IWidget,
  idx: number,
  active: boolean,
}

const Widget: React.FC<Props> = (props) => {

  const [loading, err, Component] = useRemoteComponent(
    props.widget.collapsed_url + '?v' + props.widget.version
  );

  if (err != null) {
    return (
      <div>Unknown Error: {err.toString()}</div>
    );
  }

  const ErrorFallback = ({ error }: FallbackProps) => {
    return (
      <div role="alert">
        <p style={{ fontSize: 10 }}>The &quot;{props.widget.title}&quot; widget failed to load</p>
        <pre style={{ display: 'none' }}>{error.message}</pre>
        {/* <button onClick={resetErrorBoundary}>Try again</button> */}
      </div>
    )
  }

  return (
    <div
      className={'widget' + Classify.addClassName(props.active, 'active')}
      style={{ padding: 5, position: 'relative', breakInside: 'avoid' }}
    >
      <div style={{
        border: 0,
        height: 81,
        position: 'relative'
      }}>
        {loading
          ? (<div className='widget-collapsed' />)
          : (
            <ErrorBoundary
              FallbackComponent={ErrorFallback}
              resetKeys={[props.children]}
            ><Component {...props} />
            </ErrorBoundary>
          )
        }
      </div>
    </div>
  );
}

export default Widget;